module.exports = __webpack_public_path__ + "static/loading-e50ee1cb8262a1501c44f8932dfb58ac.gif";